<ng-template [appTopbarTemplate]>
  <div class="title">
    <sc-avatar class="me-3" size="xs" [user]="candidate"></sc-avatar>
    <h4 class="mb-0 oneline">{{ candidate?.FirstName }} {{ candidate?.LastName }} <span
        class="default fw-normal text-normal ms-2" *ngIf="candidate?.JobTitle">{{candidate?.JobTitle}}</span> <span
        class="default fw-normal text-normal" *ngIf="candidate?.Company"> @ {{candidate?.Company}}</span></h4>

  </div>
</ng-template>

<div class="scroll-dummy" *ngIf="!candidate"></div>

<div class="content" [@fadeIn]="state">

  <div class="container">
    <div class="row">
      <div class="col-12">



        <div *ngIf="candidate && project">
          <div class="row">
            <div class="col-12">
              <app-notification-candidate [candidate]="candidate" [project]="project" [items]="notifications"
                [language]="loc.language"></app-notification-candidate>
            </div>
          </div>
        </div>

        <div *ngIf="candidate">
          <div class="row">

            <div class="col-12">
              <div class="card">
                <div class="card-body">
                  <app-candidate-base [candidate]="candidate" [project]="project"></app-candidate-base>
                </div>


              </div>
            </div>

            <ng-container *ngIf="!project" [ngTemplateOutlet]="activities"></ng-container>

            <div class="col-12 mt-5" *ngIf="candidate?.Screening?.RequirementResults?.length">
              <div class="card">
                <div class="card-header">
                  <h5 class="card-title">Analyse</h5>
                </div>
                <div class="card-body card-body-list">
                  <app-candidate-analysis [candidate]="candidate"></app-candidate-analysis>
                </div>
              </div>
            </div>

            <div class="col-12 mt-5">

              <div class="card">
                <div class="card-header">
                  <h5 class="card-title">Lebenslauf</h5>
                </div>
                <div class="card-body">

                  <app-candidate-skills [candidate]="candidate" [assignment]="assignment"></app-candidate-skills>
                  <app-candidate-experience class="d-block mt-5" [candidate]="candidate"></app-candidate-experience>
                  <app-candidate-education class="d-block mt-5" [candidate]="candidate"></app-candidate-education>
                  <!-- <app-candidate-feedback *ngIf="!isLoading" [candidate]="candidate" [project]="project"></app-candidate-feedback> -->
                </div>
              </div>
            </div>



            <!-- <div class="col-12 mt-5">
              <div class="card">
                <div class="card-header">
                  <h5 class="card-title">Social Media Aktivität</h5>
                </div>
                <div class="card-body">
                  <app-candidate-posts [candidate]="candidate"></app-candidate-posts>
                </div>
              </div>
            </div> -->

            <div class="col-12 mt-5" *ngIf="candidate.ScreeningAnswers?.length">
              <div class="card">
                <div class="card-header">
                  <h5 class="card-title">Screening-Fragen</h5>
                </div>
                <div class="card-body">
                  <app-candidate-screening-questions [candidate]="candidate"></app-candidate-screening-questions>
                </div>
              </div>
            </div>

            <ng-container *ngIf="project" [ngTemplateOutlet]="activities"></ng-container>

          </div>
        </div>

        <!-- pool candidates have no project to follow, so their activities come first -->
        <ng-template #activities>
          <div class="col-12 mt-5">
            <div class="card card">
              <div class="card-header">
                <h5 class="card-title">Aktivitäten</h5>
              </div>
              <div class="card-body card-body-list">
                <app-candidate-activities *ngIf="!isLoading" [candidate]="candidate"
                  [project]="project"></app-candidate-activities>
              </div>
            </div>
          </div>
        </ng-template>
      </div>
    </div>
  </div>

</div>

<!-- <app-footer-blob></app-footer-blob>-->